import React from 'react';

import { useDataAttributes } from '@lumapps/data-attributes';
import { Menu } from '@lumapps/lumx-menu/components/Menu';
import { robotSparkle } from '@lumapps/lumx/custom-icons';
import { useTranslate } from '@lumapps/translations';

import { useOpenPageWriterAgent } from '../../hooks/useOpenPageWriterAgent';
import { DESIGNER_AGENT } from '../../keys';

export interface PageWriterAgentMenuItemProps {
    /** The data-attributes scope to use for tracking */
    scope: string;
}

export const PageWriterAgentMenuItem: React.FC<PageWriterAgentMenuItemProps> = ({ scope }) => {
    const { translateKey } = useTranslate();
    const handleClick = useOpenPageWriterAgent();
    const { get } = useDataAttributes(scope);

    return (
        <Menu.Item icon={robotSparkle} onClick={handleClick} {...get({ element: 'page-writer-agent' })}>
            {translateKey(DESIGNER_AGENT.CREATE_WITH_PAGE_WRITER_AGENT)}
        </Menu.Item>
    );
};
